<template>
    <div>跳转中...</div>
</template>
<script>
export default {
    mounted(){
        location.href = 'weixin://dl/business/?t=SDIOiLzWGLe'
    }
}
</script>

